import Multimedia from "@sharedComponents/multimedia";
import { ExternalButton } from "@sharedComponents/buttons";

import { useConfig } from "@stadium/hooks/lib/use-config";
import { useWorkspaceContext } from "@contexts/workspace-context";

import { getLockerShopFeUrl } from "@stadium/redux-utils/selectors/configSelector";

import bannerImg from "@assets/images/character-working.png";

import styles from "./main.module.scss";

const ChooseMoreSwagBanner = ({ hasNoProducts = false }) => {
  const { getLockerShopUrlWithCurrentWorkspaceSlug } = useWorkspaceContext();
  const lockerShopDefaultUrl = useConfig(getLockerShopFeUrl);
  const lockerShopFeUrl = getLockerShopUrlWithCurrentWorkspaceSlug(lockerShopDefaultUrl);

  return (
    <div className={styles.swagBundleSection}>
      <div className={styles.swagRow}>
        <div className={styles.imgContent}>
          <div className={styles.characterImg}>
            <Multimedia
              src={bannerImg}
              type="image"
              alt="No results found"
              className={styles.characterImg}
            />
          </div>
        </div>
        <div className={styles.swagContent}>
          <div className={styles.swagTitle}>
            {hasNoProducts ? "No swag is available" : "Want to have more swag to choose from?"}
          </div>
          <div className={styles.swagSubTitle}>
            Design {hasNoProducts && "or purchase"} swag to add to your kit
          </div>
          <div className={styles.swagButtons}>
            <ExternalButton href={lockerShopFeUrl} styleType="primary" className={styles.button}>
              Browse Catalog
            </ExternalButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChooseMoreSwagBanner;
